import { useMutation } from '@gogame/query';

import { editPromoCode } from 'scenes/PromoCodes/sources/promoCodes';

import { update } from '../queryKeyFactory';
import { errorMessageGetter } from './useErrorDifferentFormatGetter';

export const useUpdatePromoCode = () => {
  const updateMutation = useMutation(update(), editPromoCode, {
    successMessage: () => 'Promo Code Updated',
    errorMessage: errorMessageGetter,
  });
  return [updateMutation.mutateAsync, updateMutation];
};
